<template>
    <AppModal ref="modal" :title="$t('labels.disconnect_products')" size="lg" @on-hide="hide">
        <div class="modal-body">
            <template v-if="task.state.isRunning">
                <TaskProgressBar :done="task.state.done" :total="task.state.total"/>
            </template>
            <template v-else>
                <p>{{ $t('alerts.disconnect_products_warning1') }}</p>
                <p>{{ $t('alerts.disconnect_products_warning2') }}</p>
                <p>{{ $t('alerts.disconnect_products_warning3') }}</p>
                <div class="row" v-if="allChecked && productUuids.length < totalProducts">
                    <div class="col-lg-6">
                        <InputGroup>
                            <Radio :model-value="disconnectOption === 'selected'" @update:modelValue="disconnectOption = 'selected'" />
                            <template #append>
                                {{ $t('labels.disconnect_only_selected_products', {total: productUuids.length}) }}
                            </template>
                        </InputGroup>
                    </div>
                    <div class="col-lg-6">
                        <InputGroup>
                            <Radio :model-value="disconnectOption === 'all'" @update:modelValue="disconnectOption = 'all'" />
                            <template #append>
                                {{ $t('labels.confirm_all_products_disconnection', {total: totalProducts}) }}
                            </template>
                        </InputGroup>
                    </div>
                </div>
            </template>
        </div>
        <div class="modal-footer d-flex justify-content-end">
            <AppButton color="light" class="mr-2" @click="hide">{{ $t('buttons.no') }}</AppButton>
            <AppButton color="danger" @click="detach">{{ $t('buttons.yes') }}</AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../../components/new/modal/AppModal.vue';
import AppButton from '../../../../../../components/new/button/AppButton.vue';
import TaskProgressBar from '../../../../../../components/new/progress/TaskProgressBar.vue';
import Radio from '../../../../../../components/new/form/radio/Radio.vue';
import InputGroup from '../../../../../../components/new/form/InputGroup.vue';

import HttpRequest from '../../../../../../services/Http/HttpRequest';
import HttpSender from '../../../../../../services/Http/HttpSender';
import { httpClient } from '../../../../../../services/HttpClient';
import { chunk } from '../../../../../../utils';
import { createProgressTask } from '../../../../../../services/Progress/ProgressTask';

export default {
    name: "DisconnectIntegrationProductsModal",
    components: {
        AppModal, AppButton, TaskProgressBar, Radio, InputGroup
    },
    emits: ['products:detached'],
    data() {
        return {
            task: createProgressTask(),
            productUuids: [],
            filters: {},
            allChecked: false,
            totalProducts: 0,
            disconnectOption: 'selected'
        }
    },
    methods: {
        show(productUuids, filters, allChecked, totalProducts) {
            this.filters = filters;
            this.productUuids = productUuids;
            this.allChecked = allChecked;
            this.totalProducts = totalProducts;
            this.$refs.modal.show();
        },
        hide() {
            this.task.cancel();
            this.$refs.modal.hide();
            this.productUuids = [];
            this.filters = {};
            this.allChecked = false;
            this.totalProducts = 0;
            this.disconnectOption = 'selected';
        },
        async detach() {
            const completed = await this.task.run(async (progress) => {
                if (this.disconnectOption === 'all') {
                    this.productUuids = await this.fetchProductUuids(progress);
                } else {
                    let productsUuidsWhoHasConnection = [];

                    for (let uuids of chunk(this.productUuids, 10)) {
                        if (progress.signal.aborted) {
                            return;
                        }

                        await httpClient.get(`/integrations/${this.$route.params.integrationUuid}/products`, {
                            uuids: uuids,
                            has_product: 1
                        }).then(response => {
                            productsUuidsWhoHasConnection.push(...response.data.data.map(product => product.uuid));
                        });
                    }

                    this.productUuids = productsUuidsWhoHasConnection;
                }

                const requests = this.productUuids.map(uuid => {
                    return new HttpRequest(`PATCH`, `/integrations/products/${uuid}`, {
                        product_item_uuid: null
                    })
                })

                progress.setTotal(requests.length);

                await new HttpSender().sendRequestsInBatches(requests, () => progress.tick());
            });

            if (completed) {
                this.$emit('products:detached');
                this.hide();
            }
        },
        async fetchProductUuids({tick}) {
            let total = 0,
                requests = [],
                perPage = 10,
                result = [];

            await httpClient.get(`/integrations/${this.$route.params.integrationUuid}/products`, {
                limit: 1,
                has_product: 1,
                ...this.filters,
            }).then(response => {
                total = response.data.meta.total;
            });

            const totalPages = Math.ceil(total / perPage);

            for (let page = 1; page <= totalPages; page++) {
                requests.push(new HttpRequest('GET', `/integrations/${this.$route.params.integrationUuid}/products`, {
                    limit: perPage,
                    page: page,
                    has_product: 1,
                    ...this.filters,
                }));
            }

            await new HttpSender().sendRequests(requests, (request, response, index) => {
                tick();
                result.push(...response.body.data.map(product => product.uuid));
            });

            return result;
        }
    },
    beforeUnmount() {
        this.task.cancel();
    }
}
</script>